module.exports = __webpack_public_path__ + "img/oval.f8c0258a.png";